import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { BookingStep } from '@ibe/models/ui';
import { takeWhile } from 'rxjs/operators';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';

import * as fromStore from '@ibe/store/index';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import { BookedTrip } from '@ibe/models';
import * as _ from 'lodash';

import { SESSION_VAR_KEY_MARKET,
		DEFAULT_MARKET,
		COUNTRY_CODE_PORTUGAL,
		AIRPORT_CODES_VAR_KEY_MADEIRA_DISCOUNT,
		AIRPORT_CODES_VAR_KEY_AZORES_DISCOUNT,
		ALL_CABIN_CODE
		} from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-filter-flights',
	templateUrl: './filter-flights.indra.component.html',
	styleUrls: ['./filter-flights.component.scss']
})
export class INDRAFilterFlightsComponent implements OnInit, OnDestroy {
	isAlive = true;

	scheduleOptions = [
		{ value: 'morning', label: 'Morning (04h-12h)' },
		{ value: 'afternoon', label: 'Afternoon (12h-19h)' },
		{ value: 'evening', label: 'Evening (19h-04h)' }
	];

	airlinesFilter = [];

	cabinOptionsFilter = [];

	form: FormGroup;
	hasStopover = false;
	
	// Corp
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;
	// promoname: string;

	bookingSteps$: Observable<Array<BookingStep>> = this.store.select(fromStore.getSelectedBookingSteps);
	bookingSteps: Array<BookingStep>;
	directFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterDirectFlights);
	directFlights: boolean;
	cabinOptions$: Observable<string> = this.store.select(fromStore.getFlightsFilterCabinOptions);
	cabinOptions: string;
	airline$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterAirline);
	airline: boolean;
	baggageIncluded$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBaggageIncluded);
	baggageIncluded: boolean;
	onlyRefundable$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterOnlyRefundable);
	onlyRefundable: boolean;
	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;
	schedule$: Observable<any> = this.store.select(fromStore.getFlightsFilterSchedule);
	schedule: boolean;
	searchRoutes$: Observable<Array<any>> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoutes: Array<any> = [];
	private user_info$: Observable<any> = this.store.select(fromStore.getUserInfo);
	passengerTypeStudent$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterStudentPassenger);
	passengerTypeStudent: boolean;
	passengerTypeLiveAzoresMadeira$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterLiveAzoresMadeiraPassenger);
	passengerTypeLiveAzoresMadeira: boolean;
	routeType$: Observable<any> = this.store.select(fromStore.getMiniIBERouteType);
	route_type;
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip: BookedTrip;

	flightFilter$: Observable<any> = this.store.select(fromStore.getFlightsFilterState);
	flightFilter;
	starAlliance;

	madeiraAzoresResidentDiscount: boolean = false;
	madeiraAzoresStudentDiscount: boolean = false;
	showAzoresMadeiraDiscount: boolean = false;
  	user_info;
	showUserStudent: boolean = false;
	showMulticity: boolean = true;
	hasChanges$: Observable<any> = combineLatest(
		this.searchRoutes$,
		this.bookingSteps$,
	);
	airlines: any;

	passengerTypeDiscount: boolean = false;
	residentDiscount: boolean = false;

	constructor(
		private fb: FormBuilder,
		private sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		protected ibeAdminService: INDRAIbeAdminService
	) {
		/* note: from post-sprint 8 client code merge
		this.isCorporate$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isCorporate = value;
				if (value === true) {
					this.promoname = 'corporate promo';
				} else {
					this.promoname = 'miles discount';
				}
			});
		*/
			
		this.bookAwardFlights$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.bookAwardFlights = value;
			});

		this.flightFilter$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.flightFilter = value;
				this.starAlliance = value.starAlliance;

				if (this.starAlliance && this.bookAwardFlights) {
					if (this.cabinOptionsFilter.map(v => v.id).indexOf('staralliance') < 0) {
						this.cabinOptionsFilter.push({
							id: 'staralliance', selected: this.cabinOptions === 'staralliance', label: this.INDRA_getTranslationKey('filterFlightsSidebar.text.firstClassOnly')
						});
					}
				}
			});

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookingSteps = value;
				}
			});

		this.directFlights$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.directFlights = value;
			});

		this.cabinOptions$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.cabinOptions = value;
				this.cabinOptionsFilter = [
					// change list config, same to advance-search
					{ id: 'E', selected: this.cabinOptions === 'E', label: this.INDRA_getTranslationKey('filterFlightsSidebar.text.allCabins') },
					{ id: 'Y', selected: this.cabinOptions === 'Y', label: this.INDRA_getTranslationKey('filterFlightsSidebar.text.economyOnly') },
					{ id: 'C', selected: this.cabinOptions === 'C', label: this.INDRA_getTranslationKey('filterFlightsSidebar.text.executiveOnly') }
				];

				if (this.starAlliance && this.bookAwardFlights) {
					if (this.cabinOptionsFilter.map(v => v.id).indexOf('staralliance') < 0) {
						this.cabinOptionsFilter.push({
							id: 'staralliance', selected: this.cabinOptions === 'staralliance', label: this.INDRA_getTranslationKey('filterFlightsSidebar.text.firstClassOnly')
						});
					}
				}
			});

		this.baggageIncluded$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.baggageIncluded = value;
			});

		this.onlyRefundable$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.onlyRefundable = value;
			});

		this.airline$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.airline = value;
			});

		this.user_info$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.user_info = value;
				if (value) {
					if (this.user_info.studentFare && this.user_info.studentFare.confirm === true) {
							// this.showUserStudent = true;
						}
				}
			});

		this.passengerTypeStudent$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != null) {
					if (this.passengerTypeStudent != value) {
						this.passengerTypeStudent = value;
					}
				}
			});

		this.passengerTypeLiveAzoresMadeira$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != null) {
					if (this.passengerTypeLiveAzoresMadeira != value) {
						this.passengerTypeLiveAzoresMadeira = value + '' == 'true' ? true : false;
					}
				}
			});

		this.routeType$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.route_type = value;
					if (this.route_type === 'multicity')
						this.showMulticity = false;
				}
			});

		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.booked_trip = value;
					if (this.booked_trip.stopover === true)
						this.showMulticity = false;
				}
			});
	}

	ngOnInit() {
		// get flight and feature object from the data obj passed into the sidebarservice
		const parameters = this.sidebarService.getSidebarParameters();
		if (parameters && parameters.length) {
			this.airlines = parameters[0].airlines;
		}

		for (const i in this.airlines) {
			if (!this.airlines[i].name) {
				this.airlines[i].name = this.airlines[i].code;
			}
			if (this.flightFilter.airlines.includes(this.airlines[i].code)) {
				this.airlines[i].checked = true;
			} else {
				this.airlines[i].checked = false;
			}
			this.airlinesFilter.push(this.airlines[i]);
		}

		this.formInit();

		this.schedule$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.schedule = value;

				if (value) {
					for (const schedule in value) {
						const scheduleForm = (this.form.get('schedule') as FormArray).at(Number(schedule));
						if (scheduleForm) {
							scheduleForm.get('step').setValue(schedule);
							scheduleForm.get('departure').setValue(value[schedule].departure);
							scheduleForm.get('arrival').setValue(value[schedule].arrival);
						}
					}
				}
			});

		this.form.get('passengerTypeStudent').valueChanges
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != null) {
					if (value != this.passengerTypeDiscount) {
						this.passengerTypeDiscount = value;
					}
				}
			});

		this.form.get('passengerTypeLiveAzoresMadeira').valueChanges
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != null) {
					if (value != this.residentDiscount) {
						this.residentDiscount = value;
					}
				}
			});

		for (const i in this.bookingSteps) {
			// Check if route is between an Madeira airport and an Azores airport.
			// Check if route is between Azores airport and a mainland portugal airport.
			const flag = this.INDRA_isAzoresMadeiraDiscount(this.bookingSteps[i].departure, this.bookingSteps[i].arrival);
			if (flag) {
				this.showAzoresMadeiraDiscount = true;
				break;
			}
		}

		this.INDRA_showHideResidentStudentDiscounts();
	}

	private formInit() {
		this.form = this.fb.group({
			directFlights: [this.directFlights],
			cabinOptions: [this.cabinOptions],
			baggageIncluded: [this.baggageIncluded],
			onlyRefundable: [this.onlyRefundable],
			schedule: this.fb.array([]),
			airline: [this.airline],
			airlines: this.INDRA_buildAirlines(),
			passengerTypeStudent: [this.passengerTypeStudent],
			passengerTypeLiveAzoresMadeira: [this.passengerTypeLiveAzoresMadeira]
		});

		this.bookingSteps.forEach((item, idx) => {
			(this.form.get('schedule') as FormArray).push(this.createSchedule(idx));
		});
	}


	createSchedule(step: any = '', departure = '', arrival = ''): FormGroup {
		return this.fb.group({
			step,
			departure,
			arrival
		});
	}

	INDRA_buildAirlines() {
		const arr = this.airlinesFilter.map(v => {
			return this.fb.control(v.checked);
		});

		return this.fb.array(arr);
	}

	INDRA_saveSidebar(close?: boolean) {
		const studentDiscount =
			this.form.controls['passengerTypeStudent'].value == null ? false : this.form.controls['passengerTypeStudent'].value;
		const residentDiscount =
			this.form.controls['passengerTypeLiveAzoresMadeira'].value == null ?
				false : this.form.controls['passengerTypeLiveAzoresMadeira'].value;

		this.store.dispatch(new FlightsFilterActions.PutDirectFlight(this.form.controls['directFlights'].value));
		this.store.dispatch(new FlightsFilterActions.PutCabinOptions(this.form.controls['cabinOptions'].value));
		this.store.dispatch(new FlightsFilterActions.PutBaggageIncluded(this.form.controls['baggageIncluded'].value));
		this.store.dispatch(new FlightsFilterActions.PutOnlyRefundable(this.form.controls['onlyRefundable'].value));
		this.store.dispatch(new FlightsFilterActions.PutTypeStudent(studentDiscount));
		this.store.dispatch(new FlightsFilterActions.PutTypeLiveAzoresMadeira(residentDiscount));

		// if (!this.bookAwardFlights)
		this.store.dispatch(new FlightsFilterActions.PutAirline(this.form.controls['airline'].value));
		this.store.dispatch(new FlightsFilterActions.PutSchedule(this.form.controls['schedule'].value));

		if (this.starAlliance) {
			const airlinesFilter = this.form.controls['airlines'].value
				.map((v, i) => {
					if (v) {
						return this.airlinesFilter[i].code;
					}

					return '';
				}).filter(v => v);

			this.store.dispatch(new FlightsFilterActions.PutAirlines(airlinesFilter));
		}

		if (close) {
			this.sidebarService.closeSidebar();
		}
	}

	INDRA_clearForm(): void {
		// this.store.dispatch(new FlightsFilterActions.ResetAction);
		this.form.reset();

		if (this.airlinesFilter.length != 0) {
			this.airlinesFilter.forEach(airline => { airline.checked = false; });
		}

		this.form = this.fb.group({
			directFlights: false,
			cabinOptions: ALL_CABIN_CODE,
			baggageIncluded: false,
			onlyRefundable: false,
			schedule: this.fb.array([]),
			airline: false,
			airlines: this.INDRA_buildAirlines(),
			passengerTypeStudent: false,
			passengerTypeLiveAzoresMadeira: false
		});

		// this.formInit();

		this.cabinOptionsFilter.forEach(options => {
			if (options.id == ALL_CABIN_CODE) {
				options.selected = true;
			} else {
				options.selected = false;
			}
		});

		this.INDRA_saveSidebar(false);
	}

	INDRA_cabinOptions(value) {
		this.form.get('cabinOptions').setValue(value);
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_isPortugueseMarket() {
		let marketCode = sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
		if (!marketCode) {
			marketCode = DEFAULT_MARKET;
		}
		if (marketCode == COUNTRY_CODE_PORTUGAL) {
			return true;
		}
		return false;
	}

	INDRA_isAzoresMadeiraDiscount(from, to) {
		const azoresMadeiraCodes: Array<string> =
			[...AIRPORT_CODES_VAR_KEY_MADEIRA_DISCOUNT, ...AIRPORT_CODES_VAR_KEY_AZORES_DISCOUNT];
		const azoresCodes: Array<string> = AIRPORT_CODES_VAR_KEY_AZORES_DISCOUNT;
		const portugalCode = COUNTRY_CODE_PORTUGAL;

		if (azoresMadeiraCodes.includes(from.code) && azoresMadeiraCodes.includes(to.code)) {
			// Route is between an Madeira airport and an Azores airport.
			return true;
		} else if ((azoresCodes.includes(from.code) && to.location.countryName === portugalCode) ||
			(azoresCodes.includes(to.code) && from.location.countryName === portugalCode)) {
			// Route is between Azores airport and a mainland portugal airport.
			return true;
		}

		return false;
	}

	private INDRA_showHideResidentStudentDiscounts() {

		let hasIneligibleRouteForResidentDiscount = true;
		let hasIneligibleRouteForStudentDiscount = true;

		for (const i in this.bookingSteps) {
			const origin = this.bookingSteps[i].departure ? _.cloneDeep(this.bookingSteps[i].departure) : null;
			const destination = this.bookingSteps[i].arrival ? _.cloneDeep(this.bookingSteps[i].arrival) : null;

			if (origin && destination) {
				if (destination.resident === true) {
					hasIneligibleRouteForResidentDiscount = false;
				}
				if (destination.student === true) {
					hasIneligibleRouteForStudentDiscount = false;
				}
			}
		}
		if (hasIneligibleRouteForResidentDiscount === false) {
			this.madeiraAzoresResidentDiscount = true;
		}

		if (hasIneligibleRouteForStudentDiscount === false) {
			this.madeiraAzoresStudentDiscount = true;
		}
	}

	INDRA_showPassengerTypeStudentDiscount() {
		if (this.INDRA_isPortugueseMarket() && this.showAzoresMadeiraDiscount && this.madeiraAzoresStudentDiscount) {
			return true;
		}
		return false;
	}

	INDRA_showAzoresMadeiraDiscount() {
		if (this.INDRA_isPortugueseMarket() && this.showAzoresMadeiraDiscount && this.madeiraAzoresResidentDiscount) {
			return true;
		}
		return false;
	}

	// Disable discount for azores/madeira if student discount is selected vice versa
	INDRA_isDisable(formName: string) {
		let isDisable = false;
		if (formName === 'passengerTypeStudent' && this.form.get('passengerTypeLiveAzoresMadeira').value === true) {
			isDisable = true;
		} else if (formName === 'passengerTypeLiveAzoresMadeira' && this.form.get('passengerTypeStudent').value === true) {
			isDisable = true;
		}
		return this.hasStopover === true ? this.hasStopover : isDisable;
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
	
	/*
	TAP_getPromoName(): string {
		return this.promoname;
	}
	*/
}
